import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {twMerge} from '../../../common/twMerge';
import {Button} from '../../atoms/Button/Button';
import {Text} from '../../atoms/Text/Text';
import {ContentHomeBottomFixedButtonProps} from './ContentHomeBottomFixedButtonProps.interface';

export function ContentHomeBottomFixedButton({
  isMobile,
  className,
  onClickButton,
  title,
  price,
  discountPrice,
  discountRate,
  subTitle,
  episode,
  ...props
}: ContentHomeBottomFixedButtonProps) {
  return (
    <div
      className={twMerge(
        isMobile &&
          'fixed inset-x-0 bottom-0 z-60 flex w-full bg-theme-bg-base p-8pxr',
        className
      )}
    >
      <div
        className={twMerge(
          'flex items-center',
          isMobile
            ? 'h-54pxr grow rounded-12pxr bg-theme-solid-100 text-theme-solid-0'
            : 'h-56pxr rounded-8pxr bg-static-point-yellow text-static-mono-90'
        )}
        {...props}
      >
        <div className="flex h-full w-full">
          <Button
            className={twMerge(
              'flex grow flex-col items-center justify-center',
              isMobile ? 'px-8pxr' : 'px-15pxr',
              'bg-transparent!'
            )}
            onClick={onClickButton}
          >
            <Text
              className={
                isMobile
                  ? 'font-medium2-bold text-theme-solid-0'
                  : 'font-small2-bold'
              }
            >
              {title}
            </Text>
            {subTitle && (
              <div
                className={twMerge(
                  'flex items-center',
                  isMobile ? 'font-small2 text-theme-solid-0' : 'font-x-small1'
                )}
              >
                <Text className="line-clamp-1 text-ellipsis break-all">
                  {subTitle}
                  {episode && <>&nbsp;</>}
                </Text>
                {episode && (
                  <Text className="inline-flex shrink-0 grow">{episode}</Text>
                )}
              </div>
            )}
            {!subTitle && price && (!discountRate || !discountPrice) ? (
              <Text
                className={
                  isMobile
                    ? 'font-small2 text-theme-solid-0'
                    : 'font-small1 text-theme-solid-0'
                }
              >
                {t('common_cash_amount', {
                  values: {value: formatWithCommas(price)},
                })}
              </Text>
            ) : undefined}
            {!subTitle && price && discountRate && discountPrice ? (
              <div className="flex items-center space-x-4pxr">
                <Text
                  className={
                    isMobile
                      ? 'font-small2 text-theme-solid-60 line-through'
                      : 'font-small1 text-theme-solid-0 line-through opacity-70'
                  }
                >
                  {formatWithCommas(price)}
                </Text>
                <Text
                  className={
                    isMobile
                      ? 'font-small2 text-static-point-red'
                      : 'font-small1 text-static-point-red'
                  }
                >
                  {t('common_cash_amount', {
                    values: {value: formatWithCommas(discountPrice)},
                  })}
                </Text>
              </div>
            ) : undefined}
          </Button>
        </div>
      </div>
    </div>
  );
}
